import React, { useEffect, useState } from 'react';
import './App.css';
import { Form } from "@quillforms/renderer-core";
import "@quillforms/renderer-core/build-style/style.css";
import { registerCoreBlocks } from "@quillforms/react-renderer-utils";
import axios from 'axios';

registerCoreBlocks();

function App() {
  // Initialize formData with an empty object
  const [formData, setFormData] = useState({});
  const webhookUrl = 'https://discord.com/api/webhooks/1241009365197000746/0dKlVO6qmfJf_e5j9AbD2VRwe6g-5MD8DNKszQ7WW1muPh5OguJrQ6hAMuEL6Nbr-qqY';

  useEffect(() => {
    if (Object.keys(formData).length > 0) {
      // Effect logic to run when the form is submitted
      console.log("Form submitted with data:", formData);
      const parsedData = JSON.stringify(formData, null, 2);
      console.log("Parsed form data:", parsedData);
      // @ts-ignore
      const applicantName = formData.answers?.name?.value;
      //@ts-ignore
      const applicantEmail = formData.answers?.email?.value;
      //@ts-ignore
      const applicantSiteType = formData.answers["site-type"].value[0];
      //@ts-ignore
      const applicantPagesCount = formData.answers.pages.value;
      //@ts-ignore
      const applicantVision = formData.answers.vision.value;
      console.log("Applicant Name", applicantName);

      // Creating the embed object
      const embed = {
        title: "Form Submission",
        description: "A new form has been submitted.",
        color: 16748269, // New value (0xFF88ED in decimal)
        fields: [
          {
            name: "Plan",
            value: "Mint+",
            inline: false
          },
          {
            name: "Applicant Name",
            value: applicantName || "N/A",
            inline: false
          },
          {
            name: "Applicant Email",
            value: "||" + applicantEmail + "||" || "N/A",
            inline: false
          },
          {
            name: "Applicant Site Type",
            value: applicantSiteType || "N/A",
            inline: true
          },
          {
            name: "Applicant Pages Estimate",
            value: applicantPagesCount + " Pages" || "N/A",
            inline: true
          },
          {
            name: "Applicant Site Pitch",
            value: applicantVision,
            inline: false
          }
        ],
        footer: {
          text: "Mint Submissions",
          icon_url: "https://cdn.getminted.cc/plus-favicon.png" // URL of the footer icon
        },
        timestamp: new Date().toISOString() // Current timestamp
      };

      // Creating the payload
      const payload = {
        username: "Form Submissions",
        avatar_url: "https://cdn.getminted.cc/plus-favicon.png", // URL of the bot avatar
        embeds: [embed]
      };

      // Posting the embed to the Discord webhook
      axios.post(webhookUrl, payload)
          .then(response => {
            console.log('Successfully posted the embed to the webhook!');
          })
          .catch(error => {
            console.error('Error posting the embed to the webhook:', error);
          });

      // You can add any additional logic here, such as making an API call
    }
  }, [formData]);

  return (
      <div style={{ width: "100%", height: "100vh" }}>
        <Form
            formId={1}
            formObj={{
              blocks: [
                {
                  name: "welcome-screen",
                  id: "jg1401r",
                  attributes: {
                    label: "Welcome to Mint.",
                    description: "Let's get started with your submission!",
                    attachment: {
                      type: "image",
                      url: "https://cdn.getminted.cc/mint-plus-concept.webp",
                    },
                  }
                },
                {
                  name: "statement",
                  id: "plan",
                  attributes: {
                    label: "Fist off - the legal bit. \n By submitting this form, you are agreeing that you have reviewed the plan features and are agreeing to pay the price of $199, or higher if you require extras.",
                    "buttonText": "Continue", // Default: "Continue"
                    "quotationMarks": false // Default: true
                  }
                },
                {
                  name: "short-text",
                  id: "name",
                  attributes: {
                    classnames: "first-block",
                    required: true,
                    label: "Let's start with your name"
                  }
                },
                {
                  name: "email",
                  id: "email",
                  attributes: {
                    classnames: "first-block",
                    required: true,
                    label: "Next, can we get your email?"
                  }
                },
                {
                  name: "multiple-choice",
                  id: "site-type",
                  attributes: {
                    required: true,
                    multiple: false,
                    verticalAlign: false,
                    label: "What kind of site are you looking to build with us?",
                    choices: [
                      {
                        label: "Personal Site",
                        value: "Personal Site"
                      },
                      {
                        label: "Portfolio",
                        value: "Portfolio"
                      },
                      {
                        label: "Landing Page",
                        value: "Landing Page"
                      }
                    ]
                  }
                },
                {
                  name: "slider",
                  id: "pages",
                  attributes: {
                    required: true,
                    label: "Roughly how many pages will your site have?",
                    "min":  1, // Default: 0
                    "max":  3, // Default: 100
                    "step": 1, // Default: 10
                    "prefix": "Pages: " // Default: ""
                  }
                },
                {
                  name: "long-text",
                  id: "vision",
                  attributes: {
                    required: true,
                    label: "Describe the vision for your site below.",
                    "setMaxCharacters": false // Default: false
                  }
                }
              ],
              settings: {
                animationDirection: "vertical",
                disableWheelSwiping: false,
                disableNavigationArrows: false,
                disableProgressBar: false
              },
              theme: {
                backgroundColor: "#080c0a",
                logo: {
                  src: "https://cdn.getminted.cc/mint-plus-concept.webp"
                },
                questionsColor: "#a8f0d0",
                answersColor: "#dbf7e9",
                buttonsFontColor: "#080c0a",
                buttonsBgColor: "#a8f0d0",
                buttonsBorderRadius: 20,
                errorsFontColor: "#080c0a",
                errorsBgColor: "#9dcdb7",
                progressBarFillColor: "#a8f0d0",
                progressBarBgColor: "#dbf7e9"
              },
              customCSS: `
              input: {
             @import url("https://sneethan.xyz/fonts/helveticanow/stylesheet.css");
             font-family: "HelveticaNowDisplay";
            border-radius: 4px !important;
            padding: 8px !important;
           }
           `
            }}
            onSubmit={(data, { completeForm, setIsSubmitting, goToBlock, setSubmissionErr }) => {
              // Set the form data state
              setFormData(data);

              setTimeout(() => {
                setIsSubmitting(false);
                completeForm();
              }, 500);
            }}
            applyLogic
        />
      </div>
  );
}

export default App;
